// A button's action: runs it, shows the outcome as a short message, reports "busy" while it runs.
// Use this for every button that calls the server, instead of hand-written try/catch per button.
import { useMutation } from '@tanstack/react-query';
import { errorText } from '../api/client';
import { useNotice } from '../components/NoticeProvider';

type Options<T> = { success?: string | ((result: T) => string | undefined); onDone?: (result: T) => void };

export function useAction<A, T>(fn: (arg: A) => Promise<T>, opts: Options<T> = {}) {
  const notice = useNotice();
  const m = useMutation({
    mutationFn: fn,
    onSuccess: (result) => {
      const text = typeof opts.success === 'function' ? opts.success(result) : opts.success;
      if (text) notice(text, 'success');
      opts.onDone?.(result);
    },
    onError: (e) => notice(errorText(e), 'error'),
  });
  return { run: m.mutate, busy: m.isPending };
}
